import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  isConnected: false,
  connectionError: null,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      const newNotification = {
        id: Date.now(),
        timestamp: new Date().toISOString(),
        read: false,
        ...action.payload
      };

      state.notifications = [newNotification, ...state.notifications].slice(0, 100); // Keep last 100
      state.unreadCount = state.notifications.filter(n => !n.read).length;

      // Save to localStorage
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },

    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
      state.unreadCount = state.notifications.filter(n => !n.read).length;
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },

    markAsRead: (state, action) => {
      const notification = state.notifications.find(n => n.id === action.payload);
      if (notification) {
        notification.read = true;
        state.unreadCount = state.notifications.filter(n => !n.read).length;
        localStorage.setItem('notifications', JSON.stringify(state.notifications));
      }
    },

    markAllAsRead: (state) => {
      state.notifications = state.notifications.map(n => ({ ...n, read: true }));
      state.unreadCount = 0;
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },

    clearAll: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },

    loadNotifications: (state) => {
      const savedNotifications = localStorage.getItem('notifications');
      if (savedNotifications) {
        const parsed = JSON.parse(savedNotifications);
        state.notifications = parsed;
        state.unreadCount = parsed.filter(n => !n.read).length;
      }
    },

    setSocketConnected: (state, action) => {
      state.isConnected = action.payload;
      state.connectionError = null;
    },

    setSocketError: (state, action) => {
      state.connectionError = action.payload;
      state.isConnected = false;
    },
  },
});

export const {
  addNotification,
  removeNotification,
  markAsRead,
  markAllAsRead,
  clearAll,
  loadNotifications,
  setSocketConnected,
  setSocketError,
} = notificationSlice.actions;

export default notificationSlice.reducer;
